import { BaseModel } from 'projects/core/src/lib/models/base.model';

export class ElementModel extends BaseModel {

  // columns
  name: string;
  title: string;
  type: string;
  position: number;
  metadata: string;
  content: any;

  // relations
  marks: any = {};

  // client attributes
  permissions: any;
  activeChapter: any = null;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

}
